<template>
  <v-app>
    <v-main>
      <v-container fluid class="fill-height">
        <slot/>
      </v-container>
    </v-main>
    <snackbar></snackbar>
    <span class="px-2 py-1 text-caption grey--text version">{{ version }}</span>
  </v-app>
</template>

<script>
import snackbar from "@/components/snackbar"
export default {
  name: 'Blank',
  components: { snackbar },
  computed: {
    version() {
      return process.env.VUE_APP_VERSION
    },
  }
}
</script>

<style lang="scss" scoped>
#app {
  background: #616161 url('/images/topography.svg') center center fixed !important;
  background-size: auto;
}
.version {
  position: absolute; left: 0; bottom: 0;
}
</style>